<template functional>
  <div class="facts">
    <h2 v-if="props.header">
      {{ props.header }}
    </h2>
    <div
      class="text-center smaller text-condensed text-uppercase font-weight-bold flex-wrap"
    >
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Facts'
}
</script>
